import type traverse from 'traverse';

import { isRecord } from '@change-corgi/core/types';

const PERSON_CONTAINER_KEYS = ['user', 'viewer', 'signer', 'starter', 'author', 'member', 'staff', 'decisionmaker'];
const PERSON_SIBLING_KEYS = [
	'email',
	'firstname',
	'first_name',
	'lastname',
	'last_name',
	'phonenumber',
	'phone_number',
];

/**
 * Whether a `displayName`/`display_name` key belongs to a person record, approximated (since
 * redaction has no GraphQL type info) as: the containing object sits under a key in
 * `PERSON_CONTAINER_KEYS`, or carries a sibling key from `PERSON_SIBLING_KEYS`.
 */
export const isPersonDisplayName = (context: traverse.TraverseContext): boolean => {
	const { parent } = context;
	if (!parent) return true;
	const parentKey = typeof parent.key === 'string' ? parent.key.toLowerCase() : undefined;
	if (parentKey && PERSON_CONTAINER_KEYS.includes(parentKey)) return true;
	const siblingKeys = isRecord(parent.node) ? Object.keys(parent.node) : [];
	return siblingKeys.some((key) => PERSON_SIBLING_KEYS.includes(key.toLowerCase()));
};
